import React, { useState } from 'react';
import { useForm, Controller, SubmitHandler } from 'react-hook-form';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import InputMask from 'react-input-mask';
import {useApi} from "app/api/APIProvider";
import { Title, TitleSize } from 'shared/ui/Title/Title';
import { Text, TextSize } from 'shared/ui/Text/Text';
import { classNames } from 'shared/lib/classNames/classNames';
import { useDispatch } from 'react-redux';
import { userActions } from 'features/User';
import cls from './PhoneForm.module.scss';

type FormData = {
  phone: string;
  agreement: string;
  code: number;
};

interface PhoneFormProps {
    className?: string,
    updateUserAuthStatus?: (value: string) => void,
    timerTrigger?: (value: boolean) => void,
    methodPicker: (value: boolean) => void,
}

export const PhoneForm: React.FC<PhoneFormProps> = ({ className, updateUserAuthStatus, methodPicker, timerTrigger }) => {
    const api = useApi();
    const dispatch = useDispatch();
    const [isRegistered, setIsRegistered] = useState<boolean>(true);
    const [isUnderFourteen, setIsUnderFourteen] = useState<boolean>(false);
    const {
        control,
        handleSubmit,
        register,
        setError,
        setValue,
        formState: { errors },
    } = useForm<FormData>({ mode: 'onChange' });

    const onSubmit: SubmitHandler<FormData> = async (data) => {
        const cleanedPhoneNum = data.phone.replace(/\D/g, '');
        if (cleanedPhoneNum.length === 11) {
            if (isRegistered) {
                const newData = isRegistered ? { phone: data.phone } : data;
                api.SignIn(newData as unknown as any).then((res) => {
                    updateUserAuthStatus('Sms');
                    dispatch(userActions.setPhoneNumber(data.phone));
                }).catch((res) => {
                    setError('phone', { message: 'Пользователя не существует' });
                })
            } else {
                const newData = isRegistered ? { phone: data.phone } : data;
                api.SignUp(newData as unknown as any).then((res) => {
                    updateUserAuthStatus('Sms');
                    dispatch(userActions.setPhoneNumber(data.phone));
                }).catch((res) => {
                    setError('phone', { message: 'Пользователь существует' });
                })
            }
        } else {
            setError('phone', { message: 'Введите корректный номер телефона' })
        }
    };

    return (
        <div className={cls.formWrapper}>
            <div className={cls.modWrapper}>
                <Button
                    className={classNames(cls.modButton, { [cls.active]: isRegistered })}
                    theme={ButtonTheme.PRIMARY}
                    onClick={() => {
                        setError('phone', { message: '' })
                        setIsRegistered(true)
                        methodPicker(true);
                    }}
                >
                    Вход
                </Button>
                <Button
                    className={classNames(cls.modButton, { [cls.active]: !isRegistered })}
                    theme={ButtonTheme.PRIMARY}
                    onClick={() => {
                        setError('phone', { message: '' })
                        setIsRegistered(false);
                        methodPicker(false);
                    }}
                >
                    Регистрация
                </Button>
            </div>
            <Title className={cls.title} color="#000000A6" size={TitleSize.title_32_400}>Введите номер телефона</Title>
            <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                <div className={cls.cell}>
                    <Controller
                        name="phone"
                        control={control}
                        rules={{ required: 'Заполните поле' }}
                        render={({ field }) => (
                            <InputMask
                                className={cls.field}
                                mask="+7 (999) 999-99-99"
                                maskChar="_"
                                value={field.value}
                                onChange={(e) => {
                                    setError('phone', { message: '' })
                                    setValue('phone', e.target.value)
                                }}
                                placeholder="Номер телефона"
                            />
                        )}
                    />
                    {errors.phone && <p className={cls.error}>{errors.phone.message}</p>}
                </div>
                {
                    !isRegistered && (
                        <>
                            <div className={cls.cell}>
                                <div className={cls.ageWrapper}>
                                    <Button
                                        className={classNames(cls.modButton, { [cls.active]: isUnderFourteen })}
                                        theme={ButtonTheme.PRIMARY}
                                        onClick={() => setIsUnderFourteen(true)}
                                    >
                                        Мне меньше 14
                                    </Button>
                                    <Button
                                        className={classNames(cls.modButton, { [cls.active]: !isUnderFourteen })}
                                        theme={ButtonTheme.PRIMARY}
                                        onClick={() => setIsUnderFourteen(false)}
                                    >
                                        Мне больше 14
                                    </Button>
                                </div>
                            </div>
                            <div className={`${cls.cell} ${cls.agreement}`}>
                                <div className={cls.flexWrapper}>
                                    <input
                                        className={cls.agreementCheckbox}
                                        type="checkbox"
                                        id="agreement"
                                        name="agreement"
                                        value="true"
                                        {...register('agreement', { required: 'Выберите поле' })}
                                    />
                                    <span className="checkmark" />
                                    <label htmlFor="agreement">
                                        {
                                            !isUnderFourteen ? (
                                                <p>мне больше 14 лет, я принимаю и даю свое
                                                <a className={cls.agreementLink} target="_blank" rel="noopener noreferrer" href="https://sberbank-insurance.ru/fingram-game/political-personal-data.pdf"> согласие на обработку и передачу персональной информации</a> третьим лицам на условиях,
                                                определённых Политикой обработки персональных данных СБСЖ</p>
                                            ) : (
                                                <p>мне менее 14 лет, поэтому подтверждаю, что
                                                <a className={cls.agreementLink} target="_blank" rel="noopener noreferrer" href="https://sberbank-insurance.ru/fingram-game/political-personal-data.pdf"> согласие на обработку и передачу персональной информации</a> третьим лицам на условиях,
                                                определённых Политикой обработки персональных данных СБСЖ, дает мой законный представитель (родитель/опекун/попечитель)</p>
                                            )
                                        }
                                    </label>
                                </div>
                                {errors.agreement && <p className={cls.error}>{errors.agreement.message}</p>}
                            </div>
                        </>
                    )
                }
                <Text className={cls.notion} color="#000000A6" size={TextSize.text_14}>ООО СК «СберСтрахование жизни»</Text>
                <Button type="submit" className={cls.button} theme={ButtonTheme.PRIMARY}>
                    Получить смс
                </Button>
            </form>
        </div>
    );
};


